import { render, staticRenderFns } from "./LateralMenuBar.vue?vue&type=template&id=9318b3ec&scoped=true"
import script from "./LateralMenuBar.vue?vue&type=script&lang=js"
export * from "./LateralMenuBar.vue?vue&type=script&lang=js"
import style0 from "./LateralMenuBar.vue?vue&type=style&index=0&id=9318b3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9318b3ec",
  null
  
)

export default component.exports